import {
  ClearValueButton,
  PasteFromClipboardButton,
  SampleButton,
} from '@drodil/backstage-plugin-toolbox';
import { Button, TextField, Typography, useTheme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { useEffect, useState } from 'react';
import { Assertions } from './Assertions';
import { CharacterClasses } from './CharacterClasses';
import { Quantifiers } from './Quantifiers';

export function RegexValidator() {
  const theme = useTheme();
  const [regex, setRegex] = useState('');

  const handleChange = (event: any) => {
    setRegex(event.target.value);
  };
  const [text, setText] = useState('');

  const handleTextChange = (event: any) => {
    setText(event.target.value);
  };
  const [match, setMatch] = useState([{}]);
  const [matchCount, setMatchCount] = useState(0);
  const [matchText, setMatchText] = useState('no match');

  // Handles the regex validation and set respective states
  const handleClick = () => {
    // regex check to handle no input case
    const regexCheck = regex.length === 0 ? '^$' : regex;
    const regexp = new RegExp(regexCheck);
    const textArray = text.split('\n');
    const result: any[] = [];
    let count: number = 0;
    textArray.forEach(inputText => {
      const test = regexp.test(inputText);
      // handle if text has empty string, assign to `empty string` in order to show in UI
      result.push({
        text: inputText?.length === 0 ? 'empty string' : inputText,
        result: test,
      });
      if (test) {
        count = count + 1;
      }
    });
    setMatch(result);
    setMatchCount(count);
  };

  // Variables and method to handle sample button
  const sampleRegex = '^[0-9]*$';
  const sampleText = '123456\nregex\n4789';
  const handleSample = () => {
    setRegex(sampleRegex);
    setText(sampleText);
  };

  // Handles clear button
  const handleClear = () => {
    setRegex('');
    setText('');
    setMatch([{}]);
    setMatchCount(0);
  };

  // Handles paste from clipboard
  const handlePaste = (pasteRegex: string) => {
    setRegex(pasteRegex);
  };

  // Sets match text to be shown on UI based on matchcount
  const handleMatchText = () => {
    if (matchCount === 0) {
      setMatchText('no match');
    } else if (matchCount === 1) {
      setMatchText(`${matchCount} match`);
    } else {
      setMatchText(`${matchCount} matches`);
    }
  };

  // Execute handleMatchText whenever matchCount changes
  useEffect(handleMatchText, [matchCount]);

  // Returns the background color for each string based on match result
  const getBackgroundColor = (result: any) => {
    if (result) {
      return theme.palette.primary.light;
    }
    return theme.palette.background.default;
  };
  return (
    <Grid container style={{ maxWidth: '100%' }}>
      <Grid item md={12} lg={8}>
        <Grid container sm={12}>
          <Grid item sm={12}>
            <Typography variant="body1">
              Regular Expression &emsp;
              <PasteFromClipboardButton
                setInput={pasteRegex => handlePaste(pasteRegex)}
              />
              <ClearValueButton setValue={() => handleClear()} />
              <SampleButton sample="^[0-9]*$" setInput={() => handleSample()} />
            </Typography>
            <TextField
              label="Input"
              // eslint-disable-next-line
              autoFocus
              id="input"
              multiline
              onChange={handleChange}
              fullWidth
              value={regex}
              inputProps={{ style: { resize: 'vertical' } }}
              minRows={1}
              maxRows={1}
              variant="outlined"
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <Typography variant="body1">
              Text &emsp;
              <Button
                style={{ float: 'right' }}
                variant="outlined"
                size="small"
                onClick={handleClick}
              >
                Validate
              </Button>
            </Typography>
            <TextField
              label="Input"
              id="input"
              multiline
              onChange={handleTextChange}
              value={text}
              fullWidth
              inputProps={{ style: { resize: 'vertical' } }}
              minRows={20}
              variant="outlined"
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <Typography variant="body1">
              Match Information{' '}
              <span style={{ float: 'right' }}>{matchText}</span>
            </Typography>
            <div>
              {match?.map((row: any): any => {
                return (
                  <div
                    style={{
                      whiteSpace: 'break-spaces',
                      width: 'max-content',
                      backgroundColor: getBackgroundColor(row.result),
                    }}
                  >
                    {row.text}
                  </div>
                );
              })}
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={12} lg={4}>
        <CharacterClasses />
        <Assertions />
        <Quantifiers />
      </Grid>
    </Grid>
  );
}
